/**
 * Text as it can be written into a page the handler draws.
 *
 * **Shared between the two markup modules here, where `account-markup.ts` and
 * `settings-markup.ts` each keep a copy of their own.** Those two escape by
 * habit: every string they print is a constant in the same file, and the copy
 * is there for the day one of them stops being. Search is that day. The query
 * is what a reader typed, it goes into element content and into an attribute
 * value, and the sentences come from a corpus. One escape used twice is worth
 * more here than the independence those two chose.
 *
 * It escapes both quotes as well as the three that element content needs,
 * because the query is printed into `value="..."` and a reader who types one
 * would otherwise close it. There is no context here where the wider set is
 * wrong.
 */

/** The characters that have to be written as references, in text or a value. */
const escapes = new Map([
  ["&", "&amp;"],
  ["<", "&lt;"],
  [">", "&gt;"],
  ['"', "&quot;"],
  ["'", "&#39;"],
]);

/** The pattern that finds them, built from the map so the two cannot drift. */
const escapable = new RegExp(`[${[...escapes.keys()].join("")}]`, "gu");

/** Text as it can be written inside an element or inside an attribute value. */
export function escapeHtml(text: string): string {
  return text.replaceAll(escapable, (character) => escapes.get(character)!);
}
